import React from 'react'
import Web2ServicesComponent from '../components/Web2Services';
import Web2Banner from '../components/Web2Banner';

const Web2Services = () => {
  return (
    <>
    <Web2Banner />
    <Web2ServicesComponent />
    </>
  )
}

export default Web2Services